import { useState, useEffect } from "react";
import Select from "react-select";
import api from "api/api";

//Props Validations
// import PropTypes from "prop-types";

//Material UI Components
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";

import MultiSelect from "../common/MultiSelect";

// import mui icons

//import assets
import brandImg from "../../assets/brands.png";
import calendarImg from "../../assets/calendar.jpg";
import countryImg from "../../assets/country.jpeg";
import competitorImg from "../../assets/competitor.png";
import productImg from "../../assets/product.jpg";
import productNameImg from "../../assets/product-name.jpeg";
import studyRefImg from "../../assets/study-ref.jpeg";
import studyTypeImg from "../../assets/study-type.png";
import studyTypeMethodImg from "../../assets/study-type-method.png";

// redux
import { useSelector, useDispatch } from "react-redux";
import { showNotification } from "store/features/notificationSlice";

//import components
import AlertDialogue from "./AlertDialogue";
import Loader from "../common/Loader";

import ReactSelectStyles from "../../styles/ReactSelectStyles";

function DeleteDataSeeding() {
    const dispatch = useDispatch();

    // redux store data
    const productCategoryData = useSelector((state) => state.settingsStore.productCategory);
    const productCategoryId = productCategoryData?.value || null;

    const productCategoryOptionsDataDriven = [
        {
            label: productCategoryData?.label || "",
            value: productCategoryData?.value || null,
        },
    ];

    const [idsToDelete, setIdsToDelete] = useState([]);

    const [clickedFilter, setClickedFilter] = useState("");

    const [successDialogueOpen, setSuccessDialogueOpen] = useState(false);
    const [errorDialogueOpen, setErrorDialogueOpen] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    const [deleteReasonModalOpen, setDeleteReasonModalOpen] = useState(false);
    const [deleteReason, setDeleteReason] = useState("");

    //loader variables
    const [isLoading, setIsLoading] = useState(false);
    const [loaderMessage, setLoaderMessage] = useState("Loading");

    // data driven
    // dropdowns options variables
    // const [productCategoryOptionsDataDriven, setProductCategoryOptionsDataDriven] = useState([]);
    const [studyTypeOptionsDataDriven, setStudyTypeOptionsDataDriven] = useState([]);
    const [studyTypeMethodOptionsDataDriven, setStudyTypeMethodOptionsDataDriven] = useState([]);
    const [unileverBrandOptionsDataDriven, setUnileverBrandOptionsDataDriven] = useState([]);
    const [competitorBrandOptionsDataDriven, setCompetitorBrandOptionsDataDriven] = useState([]);
    const [countryOptionsDataDriven, setCountryOptionsDataDriven] = useState([]);
    const [studyPeriodOptionsDataDriven, setStudyPeriodOptionsDataDriven] = useState([]);
    const [studyReferenceOptionsDataDriven, setStudyReferenceOptionsDataDriven] = useState([]);
    const [projectNameOptionsDataDriven, setProjectNameOptionsDataDriven] = useState([]);

    const [filters, setFilters] = useState({
        productCategory: productCategoryOptionsDataDriven[0],
        studyType: [],
        studyTypeMethod: [],
        unileverBrand: [],
        competitorBrand: [],
        country: [],
        projectName: [],
        studyPeriod: [],
        studyReference: [],
    });

    // refactored useEffect--start
    useEffect(() => {
        const payload = createPayload(filters);
        const url = `${process.env.REACT_APP_SERVER_PATH}/core-data-models/data-filter/`;

        api.post(url, payload).then(handleResponse).catch(handleError);
    }, [filters]);

    const createPayload = (filters) => {
        const payload = {};
        Object.keys(filters).forEach((key) => {
            if (key === "productCategory") {
                payload[key] = `${productCategoryId}`;
            } else {
                payload[key] = filters[key].length !== 0 ? filters[key].map((item) => item.value).join(",") : "";
            }
        });
        return payload;
    };

    const formatDropdownOption = (title, studyTypeTitle) => {
        const textColor = studyTypeTitle.toLowerCase() === "home use test" ? "#005eef" : "#4CAF50";
        return (
            <div>
                <span>{title}</span>
                <span style={{ color: textColor }}>{` (${studyTypeTitle})`}</span>
            </div>
        );
    };

    const handleResponse = (res) => {
        if (Object.keys(res.data).length > 0) {
            for (const key in res.data) {
                const temp = mapData(res.data[key], key);
                updateOptionsDataDriven(key, temp);
            }
        }
        setIsLoading(false);
    };

    const mapData = (data, key) => {
        let finalData = [];
        if (key === "study_type") {
            finalData = data.sort((a, b) => b.title.localeCompare(a.title));
        } else {
            finalData = data;
        }
        return finalData.map((datum) => {
            const obj = {
                value: datum.id,
                label: datum.title,
            };

            // Add this condition for study_type_method
            if (key === "study_type_method") {
                const optionLabel = formatDropdownOption(datum.title, datum.study_type__title);
                return {
                    ...obj,
                    htmlLabel: optionLabel,
                };
            }

            if (key === "project_name" || key === "study_reference") {
                obj["coreDataId"] = datum.core_data_id;
            }
            return obj;
        });
    };

    const updateOptionsDataDriven = (key, options) => {
        const skipMap = {
            project_name: ["projectName", "studyReference"],
            study_reference: ["studyReference", "projectName"],
        };

        const defaultMap = {
            study_type: setStudyTypeOptionsDataDriven,
            study_type_method: setStudyTypeMethodOptionsDataDriven,
            unilever_brands: setUnileverBrandOptionsDataDriven,
            competitor_brands: setCompetitorBrandOptionsDataDriven,
            country: setCountryOptionsDataDriven,
            study_period: setStudyPeriodOptionsDataDriven,
            project_name: setProjectNameOptionsDataDriven,
            study_reference: setStudyReferenceOptionsDataDriven,
        };

        const camelCaseKey = keyToCamelCase(key);
        if (filters[camelCaseKey] && filters[camelCaseKey].length > 0) {
            return;
        }
        const shouldSkip = skipMap[key] ? skipMap[key].includes(clickedFilter) : false;

        if (!shouldSkip && defaultMap[key]) {
            defaultMap[key](options);
        }
    };

    const keyToCamelCase = (key) => {
        const map = {
            study_type: "studyType",
            study_type_method: "studyTypeMethod",
            unilever_brands: "unileverBrand",
            competitor_brands: "competitorBrand",
            country: "country",
            study_period: "studyPeriod",
            project_name: "projectName",
            study_reference: "studyReference",
        };
        return map[key];
    };

    const handleError = (type, error) => {
        dispatch(showNotification({ severity: type, data: error }));
    };

    // refactored useEffect--end

    // refactored handleDelete--start
    const handleDelete = async (e) => {
        e.preventDefault();

        const ids = idsToDelete;

        if (ids.length === 0) {
            setErrorMessage("Please select a Study Reference");
            setErrorDialogueOpen(true);
            return;
        }

        const url = `${process.env.REACT_APP_SERVER_PATH}/core-data-models/batch-delete/`;
        const payload = {
            ids: ids.join(","),
            reason: deleteReason,
        };

        setLoaderMessage("Deleting...");
        setIsLoading(true);
        setDeleteReasonModalOpen(false);

        try {
            await api.post(url, payload);
            handleSuccess();
        } catch (error) {
            handleDeleteError(error);
        }
    };

    const handleSuccess = () => {
        setIsLoading(false);
        handleReset();
        setSuccessDialogueOpen(true);
    };

    const handleDeleteError = (error) => {
        setIsLoading(false);
        const message = getErrorMessage(error);
        setErrorMessage(message);
        setErrorDialogueOpen(true);
    };

    const getErrorMessage = (error) => {
        if (error?.response?.data && error.response.data.length !== 0) {
            return Object.keys(error.response.data)
                .map((key) => `${key}: ${error.response.data[key]}`)
                .join(", ");
        }
        return error.message;
    };
    // refactored handleDelete--end

    const handleReset = () => {
        setFilters({
            ...filters,
            // productCategory: [],
            studyType: [],
            studyTypeMethod: [],
            unileverBrand: [],
            competitorBrand: [],
            country: [],
            projectName: [],
            studyPeriod: [],
            studyReference: [],
        });
        setClickedFilter("");
        setIdsToDelete([]);
    };

    const handleSuccessClose = () => {
        setSuccessDialogueOpen(false);
    };

    const handleErrorClose = () => {
        setErrorDialogueOpen(false);
    };

    const handleDeleteReasonOpen = () => {
        setDeleteReasonModalOpen(true);
    };

    const handleDeleteReasonClose = () => {
        setDeleteReasonModalOpen(false);
    };

    const handleReasonInputChange = (e) => {
        setDeleteReason(e.target.value);
    };

    const handleChange = (selected, name) => {
        let tempFilters = { ...filters };
        tempFilters[name] = selected;
        setFilters((prevState) => ({
            ...prevState,
            [name]: name !== "productCategory" ? selected : [selected],
        }));

        setClickedFilter(name);
        if (name === "studyReference") {
            if (selected.length > 0) {
                const selectedArr = selected.map((ele) => ele.value);
                const projName = projectNameOptionsDataDriven.filter((ele) => selectedArr.includes(ele.value));
                setIdsToDelete([...selected.map((item) => item.coreDataId)]);
                setFilters((prevState) => ({
                    ...prevState,
                    projectName: [...projName],
                }));
            } else {
                setIdsToDelete([]);
                setFilters((prevState) => ({
                    ...prevState,
                    projectName: [],
                }));
            }
        }
        if (name === "projectName") {
            if (selected.length > 0) {
                const selectedArr = selected.map((ele) => ele.value);
                const studyRef = studyReferenceOptionsDataDriven.filter((ele) => selectedArr.includes(ele.value));
                setIdsToDelete([...selected.map((item) => item.coreDataId)]);
                setFilters((prevState) => ({
                    ...prevState,
                    studyReference: [...studyRef],
                }));
            } else {
                setIdsToDelete([]);
                setFilters((prevState) => ({
                    ...prevState,
                    studyReference: [],
                }));
            }
        }
    };

    return (
        <>
            {isLoading && <Loader message={loaderMessage} />}
            <div className="container-fluid">
                <form>
                    <div className="row justify-content-md-center mt-0 mb-0 row-cols-5">
                        <div className="col">
                            <div className="dropdown-card box-shadow--cards">
                                <div className="dropdown-cards-image-container">
                                    <img
                                        className="dropdown-card-image"
                                        src={productImg}
                                        alt={"Product"}
                                    />
                                </div>
                                <div className="dropdown-card-dropdown-container ">
                                    <Select
                                        styles={ReactSelectStyles}
                                        className="dropdown dropdown-first-row"
                                        placeholder={"Product Category"}
                                        value={filters.productCategory}
                                        options={productCategoryOptionsDataDriven}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="dropdown-card box-shadow--cards">
                                <div className="dropdown-cards-image-container">
                                    <img
                                        className="dropdown-card-image"
                                        src={studyTypeImg}
                                        alt={"Study Type"}
                                    />
                                </div>
                                <div className="dropdown-card-dropdown-container ">
                                    <MultiSelect
                                        styles={ReactSelectStyles}
                                        className="dropdown dropdown-first-row"
                                        placeholder={"Study Type"}
                                        key="studyType"
                                        options={studyTypeOptionsDataDriven}
                                        onChange={(newValue) => handleChange(newValue, "studyType")}
                                        value={filters.studyType}
                                        isSelectAll={true}
                                        menuPlacement={"bottom"}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="dropdown-card box-shadow--cards">
                                <div className="dropdown-cards-image-container">
                                    <img
                                        className="dropdown-card-image"
                                        src={studyTypeMethodImg}
                                        alt={"Brand"}
                                    />
                                </div>
                                <div className="dropdown-card-dropdown-container ">
                                    <MultiSelect
                                        styles={{ ...ReactSelectStyles, valueContainer: (base) => ({ ...base, flexWrap: "nowrap" }) }}
                                        className="dropdown dropdown-first-row"
                                        placeholder={"Study Type Method"}
                                        key="studyTypeMethod"
                                        options={studyTypeMethodOptionsDataDriven}
                                        onChange={(newValue) => handleChange(newValue, "studyTypeMethod")}
                                        value={filters.studyTypeMethod}
                                        isSelectAll={true}
                                        menuPlacement={"bottom"}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="dropdown-card box-shadow--cards">
                                <div className="dropdown-cards-image-container">
                                    <img
                                        className="dropdown-card-image"
                                        src={brandImg}
                                        alt={"Brand"}
                                    />
                                </div>
                                <div className="dropdown-card-dropdown-container ">
                                    <MultiSelect
                                        styles={{ ...ReactSelectStyles, valueContainer: (base) => ({ ...base, flexWrap: "nowrap" }) }}
                                        className="dropdown dropdown-first-row"
                                        placeholder={"Unilever Brand"}
                                        key="unileverBrand"
                                        options={unileverBrandOptionsDataDriven}
                                        onChange={(newValue) => handleChange(newValue, "unileverBrand")}
                                        value={filters.unileverBrand}
                                        isSelectAll={true}
                                        menuPlacement={"bottom"}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="dropdown-card box-shadow--cards">
                                <div className="dropdown-cards-image-container">
                                    <img
                                        className="dropdown-card-image"
                                        src={competitorImg}
                                        alt={"competitor"}
                                    />
                                </div>
                                <div className="dropdown-card-dropdown-container ">
                                    <MultiSelect
                                        styles={{ ...ReactSelectStyles, valueContainer: (base) => ({ ...base, flexWrap: "nowrap" }) }}
                                        className="dropdown dropdown-first-row"
                                        placeholder={"Benchmark Brand"}
                                        key="competitorBrand"
                                        options={competitorBrandOptionsDataDriven}
                                        onChange={(newValue) => handleChange(newValue, "competitorBrand")}
                                        value={filters.competitorBrand}
                                        isSelectAll={true}
                                        menuPlacement={"bottom"}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        style={{ marginTop: 30 }}
                        className="row justify-content-md-center mb-0 row-cols-5"
                    >
                        <div className="col">
                            <div className="dropdown-card box-shadow--cards">
                                <div className="dropdown-cards-image-container">
                                    <img
                                        className="dropdown-card-image"
                                        src={countryImg}
                                        alt={"Country"}
                                    />
                                </div>
                                <div className="dropdown-card-dropdown-container ">
                                    <MultiSelect
                                        styles={{ ...ReactSelectStyles, valueContainer: (base) => ({ ...base, flexWrap: "nowrap" }) }}
                                        className="dropdown"
                                        placeholder={"Country"}
                                        key="country"
                                        options={countryOptionsDataDriven}
                                        onChange={(newValue) => handleChange(newValue, "country")}
                                        value={filters.country}
                                        isSelectAll={true}
                                        menuPlacement={"bottom"}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="dropdown-card box-shadow--cards">
                                <div className="dropdown-cards-image-container">
                                    <img
                                        className="dropdown-card-image"
                                        src={calendarImg}
                                        alt={"Study Period"}
                                    />
                                </div>
                                <div className="dropdown-card-dropdown-container ">
                                    <MultiSelect
                                        styles={ReactSelectStyles}
                                        className="dropdown"
                                        placeholder={"Study Period"}
                                        key="studyPeriod"
                                        options={studyPeriodOptionsDataDriven}
                                        onChange={(newValue) => handleChange(newValue, "studyPeriod")}
                                        value={filters.studyPeriod}
                                        isSelectAll={true}
                                        menuPlacement={"bottom"}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="col">
                            <div className="dropdown-card box-shadow--cards">
                                <div className="dropdown-cards-image-container">
                                    <img
                                        className="dropdown-card-image"
                                        src={productNameImg}
                                        alt={"Product Name"}
                                    />
                                </div>
                                <div className="dropdown-card-dropdown-container">
                                    <MultiSelect
                                        styles={{ ...ReactSelectStyles, valueContainer: (base) => ({ ...base, flexWrap: "nowrap" }) }}
                                        className="dropdown"
                                        placeholder={"Project Name"}
                                        key="projectName"
                                        options={projectNameOptionsDataDriven}
                                        onChange={(newValue) => handleChange(newValue, "projectName")}
                                        value={filters.projectName}
                                        isSelectAll={true}
                                        menuPlacement={"bottom"}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="dropdown-card box-shadow--cards">
                                <div className="dropdown-cards-image-container">
                                    <img
                                        className="dropdown-card-image"
                                        src={studyRefImg}
                                        alt={"Study Reference"}
                                    />
                                </div>
                                <div className="dropdown-card-dropdown-container ">
                                    <MultiSelect
                                        styles={{ ...ReactSelectStyles, valueContainer: (base) => ({ ...base, flexWrap: "nowrap" }) }}
                                        className="dropdown"
                                        placeholder={"Study Reference"}
                                        key="studyReference"
                                        options={studyReferenceOptionsDataDriven}
                                        onChange={(newValue) => handleChange(newValue, "studyReference")}
                                        value={filters.studyReference}
                                        isSelectAll={true}
                                        menuPlacement={"bottom"}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        style={{ marginTop: 20 }}
                        className="custom-btn-container custom-btn-center-container mb-0"
                    >
                        <Button
                            style={{
                                width: 185,
                            }}
                            size="small"
                            className={idsToDelete.length === 0 ? "custom-btn custom-btn--upload-reset box-shadow--3" : "custom-btn liner-light-blue-background custom-btn--upload-reset"}
                            variant="contained"
                            disabled={idsToDelete.length === 0}
                            onClick={handleDeleteReasonOpen}
                        >
                            Delete
                        </Button>
                        <Button
                            style={{
                                width: 185,
                            }}
                            size="small"
                            type="reset"
                            className="custom-btn liner-light-blue-background custom-btn--upload-reset"
                            variant="contained"
                            onClick={handleReset}
                        >
                            Reset
                        </Button>
                    </div>
                </form>
            </div>
            <AlertDialogue
                open={successDialogueOpen}
                icon="success"
                title="Success!"
                description="Your data has been deleted successfully!"
                buttons={
                    <div>
                        <Button
                            size="small"
                            onClick={handleSuccessClose}
                            style={{
                                paddingLeft: 10,
                                paddingRight: 10,
                                textTransform: "unset",
                                // height: 31.6,
                                // textAlign: "left",
                                // lineHeight: "14.5px",
                                // width: "100%",
                            }}
                            className="custom-btn-outlined color-blue"
                            variant="outlined"
                        >
                            Continue
                        </Button>
                    </div>
                }
            />
            <AlertDialogue
                open={errorDialogueOpen}
                icon="error"
                title="Error!"
                description={errorMessage}
                buttons={
                    <div>
                        <Button
                            size="small"
                            onClick={handleErrorClose}
                            style={{
                                paddingLeft: 10,
                                paddingRight: 10,
                                textTransform: "unset",
                                // height: 31.6,
                                // textAlign: "left",
                                // lineHeight: "14.5px",
                                // width: "100%",
                            }}
                            className="custom-btn-outlined color-blue"
                            variant="outlined"
                        >
                            Go Back
                        </Button>
                    </div>
                }
            />
            <Modal
                open={deleteReasonModalOpen}
                // onClose={handleDeleteReasonClose}
                disableBackdropClick={true}
                aria-labelledby="modal-title"
                aria-describedby="modal-description"
            >
                <Box sx={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", width: 400, bgcolor: "background.paper", boxShadow: 24, p: 4, textAlign: "center" }}>
                    <p
                        id="modal-title"
                        style={{ fontSize: 20, color: "rgb(51, 94, 234)" }}
                    >
                        Reason for Delete
                    </p>
                    <div id="modal-description">
                        <TextField
                            label="Reason"
                            placeholder="Provide a reason"
                            fullWidth
                            multiline
                            sx={{
                                "& label.Mui-focused": {
                                    color: "rgb(51, 94, 234)",
                                    backgroundColor: "#FFF",
                                },
                                "& .MuiOutlinedInput-root": {
                                    "&.Mui-focused fieldset": {
                                        borderColor: "rgb(51, 94, 234)",
                                    },
                                },
                            }}
                            onChange={handleReasonInputChange}
                        />
                        {/* <input type="text" style={{border:"1px solid "}} /> */}
                        <div>
                            <Button
                                size="large"
                                className="custom-btn color-blue custom-btn--upload-reset"
                                variant="outlined"
                                onClick={handleDeleteReasonClose}
                            >
                                Cancel
                            </Button>
                            <Button
                                size="large"
                                className={deleteReason === "" ? "custom-btn custom-btn--upload-reset box-shadow--3" : "custom-btn liner-light-blue-background custom-btn--upload-reset"}
                                variant="contained"
                                type="submit"
                                disabled={deleteReason === ""}
                                onClick={handleDelete}
                            >
                                Submit
                            </Button>
                        </div>
                    </div>
                </Box>
            </Modal>
        </>
    );
}

export default DeleteDataSeeding;
